module.exports = __webpack_public_path__ + "media/icons/search-ac0d491acc37193e37e42a73de8bee76.svg";